<template>
  <div class="chat-input-container">
    <input
      v-model="message"
      :placeholder="placeholder"
      :disabled="disabled"
      @keydown.enter="sendMessage"
      class="chat-input"
      type="text"
      ref="input"
    />

    <button
      @click="sendMessage"
      :disabled="disabled || !message.trim()"
      class="send-button"
      title="Send message (Enter)"
    >
      <span v-if="!disabled">→</span>
      <span v-else class="spinner"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: "ChatInput",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Tell me about your problem...",
    },
  },
  data() {
    return {
      message: "",
    };
  },
  methods: {
    sendMessage() {
      if (this.disabled || !this.message.trim()) return;

      this.$emit("send", this.message);
      this.message = "";
    },
    focus() {
      this.$refs.input?.focus();
    },
  },
};
</script>

<style scoped lang="scss">
.chat-input-container {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
}

.chat-input {
  flex: 1;
  height: 44px;
  max-width: 800px;
  padding: 12px 16px;
  font-family: inherit;
  font-size: 1rem;
  color: var(--darkColor);
  transition: border-color 0.3s;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;

  &:focus {
    outline: none;
    border-color: var(--primaryColor);
    box-shadow: 0 0 0 3px rgba(95, 151, 122, 0.1);
  }

  &:disabled {
    background-color: var(--backgroundColorLight);
    color: #999;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #999;
  }
}

.send-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  background-color: var(--primaryColor);
  color: var(--colorOnPrimary);
  border: none;
  border-radius: 8px;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    background-color: var(--primaryColorDark);
    transform: scale(1.05);
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .chat-input-container {
    padding: 12px;
    gap: 8px;
  }

  .send-button {
    width: 40px;
    height: 40px;
  }
}
</style>
